import React from 'react'

import { Grid } from '@mui/material'

const CardDataPoint = ({ label, value, isLoading = false }) => {

    let valueString = null
    if(Array.isArray(value)) {
        valueString = (<div>
                {
                    value.map(val => {
                        return (<div>{val}</div>)
                    })
                }
            </div>)
    } else {
        valueString = value
    }

    return (<Grid container spacing={2} maxWidth padding={2}>
        <Grid item xs={4}><b>{label}</b></Grid>
        <Grid item xs={8}>{!isLoading ? value ? valueString : <div className='card-data-point-strike' /> : null}</Grid>
    </Grid>)
}

export default CardDataPoint